import styled from 'styled-components';

export const CalendarsContainer = styled.div`
  .MuiTableBody-root {
    tr {
      > td {
        &:first-child {
          p {
            font-weight: 1000;
          }
        }
      }
    }
  }
`;
